"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/** @optimized using svgo:^3.0.2 */
export const ChatBubbleSquare = createSVGIcon(
  <path
    d="M7.714 21.429.857 23.143 2.57 18V2.572A1.714 1.714 0 0 1 4.286.857h17.142a1.714 1.714 0 0 1 1.715 1.715v17.143a1.714 1.714 0 0 1-1.715 1.714z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ChatBubbleSquare",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
